import { ThemeProvider } from '@mui/material/styles';
import MinimalLayout from './MinimalLayout';
import createAuthTheme from '../themes';

const authTheme = createAuthTheme({ borderRadius: 12, navType: 'light' });

export default function AuthenticationLayout() {
    return (
        <ThemeProvider theme={authTheme}>
            <MinimalLayout />
        </ThemeProvider>
    );
}
